import { MMKV } from "react-native-mmkv";
import { Platform } from "react-native";
export const storage = new MMKV({
  id: "sparrow",
  encryptionKey: Platform.select({
    web: undefined,
    default: "sparrow-encryption-key",
  }),
});

// Storage keys constants
export const STORAGE_KEYS = {
  SESSION_ID: "sessionId",
  DEVICE_ID: "deviceId",
  INSTALL_TRACKED_KEY: "@sparrow_install_tracked",
  PENDING_ATTRIBUTION_KEY: "@sparrow_pending_attribution",
  CURRENT_SESSION_KEY: "@sparrow_current_session",
  FAILED_TRACKING_QUEUE: "@sparrow_failed_tracking_queue",
} as const;

// Specific storage functions for common use cases
export const storageUtils = {
  setSessionId: (sessionId: string) =>
    storage.set(STORAGE_KEYS.SESSION_ID, sessionId),
  getSessionId: () => storage.getString(STORAGE_KEYS.SESSION_ID),
  removeSessionId: () => storage.delete(STORAGE_KEYS.SESSION_ID),

  setDeviceId: (deviceId: string) =>
    storage.set(STORAGE_KEYS.DEVICE_ID, deviceId),
  getDeviceId: () => storage.getString(STORAGE_KEYS.DEVICE_ID),
  removeDeviceId: () => storage.delete(STORAGE_KEYS.DEVICE_ID),

  // Hidden feed items storage - stored as { userId: [itemId, itemId, ...] }
  getHiddenItemsKey: () => "@sparrow_hidden_feed_items",

  getHiddenItems: (userId: string): string[] => {
    const key = storageUtils.getHiddenItemsKey();
    const data = storage.getString(key);
    if (!data) return [];
    try {
      const parsed = JSON.parse(data) as Record<string, string[]>;
      return parsed[userId] || [];
    } catch {
      return [];
    }
  },

  addHiddenItem: (userId: string, itemId: string): void => {
    const key = storageUtils.getHiddenItemsKey();
    const data = storage.getString(key);
    let parsed: Record<string, string[]> = {};
    try {
      if (data) {
        parsed = JSON.parse(data);
      }
    } catch {
      parsed = {};
    }
    const userHidden = parsed[userId] || [];
    if (!userHidden.includes(itemId)) {
      parsed[userId] = [...userHidden, itemId];
      storage.set(key, JSON.stringify(parsed));
    }
  },
};
